import * as Yup from 'yup';

import text from "../../../helpers/useText";

export const validationForm = Yup.object().shape({
  size: Yup.string()
    .required('required')
    .test('size', text.stepOne.errorSize, function(value) {
      return this.parent.max > value;
    }),
    // .test('size-limit', 'При выбраном размере системы количество вариантов превышает 1000', function(value) {
    //   const max = this.parent.max;
    //   const size = value;
    //   return !(systemSize(max, size) > 1000)
    // }),
  max: Yup.number()
    .required('required')
    .test('size', text.stepOne.errorMax, function(value) {
      return value > this.parent.size;
    }),
    // .test('size-limit', 'При выбраном размере системы количество вариантов превышает 1000', function(value) {
    //   const max = value;
    //   const size = this.parent.size;
    //   return !(systemSize(max, size) > 1000)
    // }),
  bet: Yup.number()
    .required('required')
    .test('test bet value', text.stepOne.errorBet, (value) => {
      let isValid = false;
      if (value > 0) {
        isValid = true;
      } else if (value === undefined) {
        isValid = false;
      }
      return isValid;
    })
    .typeError(text.stepOne.errorBet)

});
